import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ActionResult, ActionResultList, CategoryItem, CompetitorFilter, CompetitorResults, PagedFilter } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class CompetitorResultsService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  getCompetitorResults(filter: PagedFilter<CompetitorFilter>, isAdmin: boolean = false): Observable<CompetitorResults[]> {

    const url = isAdmin
        ? `${this.environmentService.getApiUrl()}/api/competitors/results`
        : `${this.environmentService.getApiUrl()}/api/public/competitors/results`;

    return this.http.post<ActionResultList<CompetitorResults[], number>>(url, filter).pipe(
            map(res => res?.result ?? [])
        );
  }

  getDetailedCompetitorResults(competitorId: number): Observable<CompetitorResults | undefined> {
    return this.http.get<ActionResult<CompetitorResults>>(
        this.environmentService.getApiUrl() + `/api/public/competitors/results/detailed/${competitorId}`
    ).pipe(map(value => value?.result ?? undefined));
  }

  getAllCompetitorResults(raceId: number): Observable<CompetitorResults[]> {
    // Cache busting: backend ne salje Cache-Control header pa browser kesira
    // odgovore. Bez ovoga, nakon refresha stranice fetch interval ne dohvaca
    // svjeze rezultate (browser vraca iz cachea bez novog requesta).
    const cacheBuster = `&_t=${Date.now()}`;

    return this.http.get<ActionResultList<CompetitorResults[], number>>(
        this.environmentService.getApiUrl() + `/api/public/competitors/all/results?raceId=${raceId}${cacheBuster}`
    ).pipe(map(value => {
      return value?.result?.length ? value.result : []
    }));
  }


  findCategoryItemsByRaceId(raceId: number): Observable<CategoryItem[]> {
    return this.http.get<ActionResult<CategoryItem[]>>(
      this.environmentService.getApiUrl() + `/api/public/category/race/${raceId}`
    ).pipe(map(value => value?.result?.length ? value.result : []));
  }

  findCategoryItemsByEventId(eventId: number): Observable<CategoryItem[]> {
    return this.http.get<ActionResult<CategoryItem[]>>(
      this.environmentService.getApiUrl() + `/api/public/category/event/${eventId}`
    ).pipe(map(value => value?.result?.length ? value.result : []));
  }
}
